<template>
  <div style="width: 100%">
    <nav-header v-if="$route.name=='postList' && !circleInfo.enableCustomNav " />
    <HeadNav v-else :circle-id="$route.params.id"></HeadNav>
  <div class="post-list container">

    <!-- 固定头部 -->
    <div class="fixed-header">
      <!-- 圈子信息 -->
      <el-card class="circle-info" :style="circleInfo.bgImage ? `background-image:url(${circleInfo.bgImage})` : ''">
        <div class="circle-header">
          <el-avatar :size="80" :src="circleInfo.avatar" @click="goIntro"/>
          <div class="circle-user-info" @click="goIntro">
            <h2 class="circle-name">{{circleInfo.name}}</h2>
          </div>
          <template v-if="isOwner || isAdmin">
            <el-button style="color: white" type="text" @click="showEditPopup">
              <i class="el-icon-setting"></i>
              管理
            </el-button>
          </template>
        </div>
      </el-card>

      <!-- 频道栏 -->
      <div class="channel-bar">
        <div class="left-section channel-scroll">
          <el-tabs v-model="currentChannel" @tab-click="handleChannelChange" class="scrollable-tabs">
            <el-tab-pane 
              v-for="item in channels" 
              :key="item.id"
              :label="item.name"
              :name="item.id+''"
            />
          </el-tabs>
        </div>

        <div class="right-section">
          <!-- 搜索框 -->
          <div class="search-box">
            <el-input
              v-model="searchKey"
              placeholder="搜索帖子..."
              prefix-icon="el-icon-search"
              clearable
              @input="handleSearch"
              size="small"
            >
            </el-input>
          </div>

          <!-- 精华筛选 -->
          <el-button 
            :type="postType === 'essence' ? 'primary' : 'default'"
            size="small"
            @click="toggleEssence"
            class="essence-btn"
          >
            <i class="el-icon-star-off"></i>
            精华
          </el-button>
          <el-button @click="fileDialogVisible=true" >文件</el-button>
          <!-- 发布按钮 -->
          <div class="publish-btn" >
            <el-button 
              type="primary" 
              class="btn-publish"
              @click="publish"
            >
              <i class="el-icon-edit"></i>
              发布帖子
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 帖子列表 -->
    <el-row :gutter="10">
      <el-col :md="18" >
    <div class="post-container">
      <!-- 置顶帖子区域 -->
      <div class="top-posts" v-if="topPosts.length">
        <div class="top-list">
          <div 
            v-for="item in topPosts" 
            :key="item.id" 
            class="top-item"
            @click="goDetail(item)"
          >
            <div class="top-tag">置顶</div>
            <div class="post-title">{{item.title?item.title:item.content}}</div>
          </div>
        </div>
      </div>

      <!-- 原有的帖子列表 -->
      <el-card 
        v-for="item in posts" 
        :key="item.id" 
        class="post-item"
        :class="{'is-essence': item.isEssence}"
      >
        <!-- 帖子头部 -->
        <div class="post-header">
          <div class="circle-user-info">
            <el-avatar :size="40" :src="item.imUserVo.headImageThumb"/>
            <div class="user-meta">
              <span class="nickname">{{item.imUserVo.nickName}}</span>
              <span class="time">{{item.createTime}}</span>
            </div>
          </div>
          <div class="header-right">
            <div class="post-tags">
              <el-tag v-if="item.isTop==1" type="warning">置顶</el-tag>
              <el-tag v-if="item.isEssence==1" type="success">精华</el-tag>
            </div>
            <!-- 添加更多操作按钮 -->
            <div class="post-actions">
              <el-dropdown trigger="click" @command="(command) => handleCommand(command, item)">
                <el-button type="text">
                  <i class="el-icon-more"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="essence" v-if="item.isEssence==0 && (isOwner||isAdmin)">设为精华</el-dropdown-item>
                  <el-dropdown-item command="cancelEssence" v-else-if="item.isEssence==1 && (isOwner||isAdmin)">取消精华</el-dropdown-item>
                  <el-dropdown-item command="top" v-if="item.isTop==0 && (isOwner||isAdmin)">置顶</el-dropdown-item>
                  <el-dropdown-item command="cancelTop" v-else-if="item.isTop==1 && (isOwner||isAdmin)">取消置顶</el-dropdown-item>
                  <el-dropdown-item command="edit" divided v-if="item.createBy==userStore.userInfo.id">编辑</el-dropdown-item>
                  <el-dropdown-item command="delete" divided v-if="item.createBy==userStore.userInfo.id ||(isOwner||isAdmin)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <!-- 帖子内容 -->
        <div class="post-content" >
          <pre class="post-text" :class="{'is-title': item.title}" @click="goDetail(item)">{{ item.title?item.title:item.content}}</pre>
          <pre style="font-size: 0.8rem" @click="goDetail(item)" v-if="item.excerpt" > {{item.excerpt}}</pre>
          <!-- 图片列表 -->
          <div v-if="item.images" class="image-list">
            <el-image
              v-for="(img,index) in JSON.parse(item.images)"
              :key="index"
              :src="img"
              :preview-src-list="JSON.parse(item.images)"
              fit="cover"
            />
          </div>

          <!-- 附件列表 -->
          <div v-if="item.files" class="file-list">
            <div 
              v-for="(file,index) in JSON.parse(item.files)"
              :key="index"
              class="file-item"
            >
              <i :class="getFileIcon(file.type)"></i>
              <span class="file-name">{{file.name}}</span>
              <span class="file-size">{{formatSize(file.size)}}</span>
              <div class="file-actions">
                <el-button 
                  type="text" 
                  icon="el-icon-view"
                  @click.stop="previewFile(file)"
                />
                <el-button 
                  type="text" 
                  icon="el-icon-download"
                  @click.stop="downloadFile(file)"
                />
              </div>
            </div>
          </div>
          <!--文件列表-->
          <file-manager :bus-id="item.id" v-if="item.id &&item.circleName" :parent-id="item.circleId" :pre="true" @noData="()=>{item.circleName=null}"></file-manager>
        </div>

        <!-- 帖子底部 -->
        <div class="post-footer">
          <div class="post-actions">
            <span>
              <i class="el-icon-chat-dot-round"></i>
              {{item.commentCount}}
            </span>
            <span @click.stop="toggleLike(item)">
              <i :class="item.liked ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
              {{item.likeCount}}
            </span>
          </div>
        </div>
      </el-card>
      <!-- 空状态 -->
      <p class="loading" v-if="loading">
        <i class="el-icon-loading"></i> 加载中...
      </p>
      <el-empty
          v-if="posts.length==0 && isMember && !loading"
          description="无数据"
      ></el-empty>
      <el-empty
          v-if="!isMember"
          description="加入后可见全部数据"
      ></el-empty>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :current-page="page"
          :page-size="10"
          :total="total"
          @current-change="handlePageChange"
          layout="prev, pager, next,total"
        />
      </div>
    </div>
      </el-col>
      <el-col :md="6">
        <el-card class="circle-info-card">
          <div class="info-header">
            <h3>圈子介绍</h3>
          </div>
          <div class="info-content">
            <p class="description">{{circleInfo.description}}</p>
            <div class="info-stats">
              <div class="stat-item" @click="goMemberList">
                <span class="label">成员</span>
                <span class="value">{{circleInfo.memberCount}}</span>
              </div>
              <div class="stat-item">
                <span class="label">帖子</span>
                <span class="value">{{circleInfo.postCount}}</span>
              </div>
            </div>
            <div class="info-meta">
              <div class="meta-item owner-info">
                <el-avatar :size="40" :src="owner.headImageThumb" class="owner-avatar"/>
                <div class="owner-meta">
                  <div class="owner-name">
                    <i class="el-icon-user"></i>
                    <span>圈主：{{owner.nickName}}</span>
                  </div>
                  <div class="create-time">
                    <i class="el-icon-time"></i>
                    <span>创建于：{{circleInfo.createTime}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="join-info" v-if="!isMember && !isOwner">
              <template v-if="circleInfo.joinType == 1">
                <div class="price">¥{{circleInfo.price}}</div>
                <div class="valid-days">有效期：{{circleInfo.validDays}}天</div>
              </template>
              <el-button 
                type="primary" 
                class="join-btn"
                @click="joinCircle"
              >
                {{circleInfo.joinType == 1 ? '付费加入' : '加入'}}
              </el-button>
            </div>
          </div>
        </el-card>
        <qrcode :url="'/h5/#/pages/community/post-list?id='+$route.params.id"></qrcode>
        <!-- 管理员列表 -->
        <el-card class="admin-card" v-if="admins.length">
          <div class="info-header">
            <h5>管理员</h5>
          </div>
          <div class="admin-list">
            <div class="admin-item" v-for="admin in admins" :key="admin.id">
              <el-avatar :size="32" :src="admin.user.headImageThumb"></el-avatar>
              <span class="admin-name">{{admin.user.nickName}}</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 付费加入弹窗 -->
    <el-dialog
      title="付费加入"
      :visible.sync="showPayDialog"
      width="400px"
      center
    >
      <div class="pay-content">
        <div class="pay-info">
          <span>加入费用:</span>
          <span class="price">¥{{circleInfo.price}}</span>
        </div>
        <div class="pay-info">
          <span>有效期:</span>
          <span>{{circleInfo.validDays}}天</span>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="showPayDialog = false">取消</el-button>
        <el-button type="primary" @click="showPay">确认支付</el-button>
      </span>
    </el-dialog>

    <!-- 管理弹窗 -->
    <el-dialog
      title="圈子管理"
      :visible.sync="showManageDialog"
      width="400px"
    >
      <div class="manage-menu">
        <el-button @click="editCircle">
          <i class="el-icon-edit"></i>
          编辑圈子信息
        </el-button>
        <el-button @click="goMemberList">
          <i class="el-icon-user"></i>
          成员管理
        </el-button>
        <el-button @click="manageEssence">
          <i class="el-icon-star-off"></i>
          精华管理
        </el-button>
        <el-button @click="manageTop">
          <i class="el-icon-top"></i>
          置顶管理
        </el-button>
      </div>
    </el-dialog>

    <!-- 精华管理弹窗 -->
    <el-dialog
      title="精华管理"
      :visible.sync="showEssenceDialog"
      width="600px"
    >
      <el-table :data="essencePosts">
        <el-table-column  label="内容" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span>{{row.title||row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发布时间" width="180"/>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{row}">
            <el-button 
              type="text" 
              @click="cancelEssence(row)"
            >取消精华</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 置顶管理弹窗 -->
    <el-dialog
      title="置顶管理"
      :visible.sync="showTopDialog"
      width="600px"
    >
      <el-table :data="topPosts">
        <el-table-column prop="content" label="内容" show-overflow-tooltip>
          <template slot-scope="{row}">
            <span>{{row.title||row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发布时间" width="180"/>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{row}">
            <el-button 
              type="text" 
              @click="cancelTop(row)"
            >取消置顶</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 添加成员列表对话框 -->
    <el-dialog
      title="圈子成员"
      :visible.sync="showMemberDialog"
      width="800px"
    >
      <!-- 搜索框 -->
      <div class="search-bar">
        <el-input
          v-model="memberKeyword"
          placeholder="搜索成员"
          @keyup.enter.native="searchMember"
          clearable
        >
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
      </div>

      <!-- 成员列表 -->
      <el-table :data="members">
        <el-table-column label="用户信息">
          <template slot-scope="{row}">
            <div class="member-info">
              <el-avatar :size="40" :src="row.user.headImageThumb"/>
              <span class="nickname">{{row.user.nickName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="joinTime" label="加入时间" width="180"/>
        <el-table-column prop="role" label="角色" width="100">
          <template slot-scope="{row}">
            <el-tag v-if="row.userId==circleInfo.createBy" type="danger">圈主</el-tag>
            <el-tag v-else-if="row.role === 1" type="warning">管理员</el-tag>
            <el-tag v-else>成员</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{row}">
            <template v-if="isOwner">
              <el-button 
                v-if="row.role == 0 && row.userId!=circleInfo.createBy"
                type="text"
                @click="setAdmin(row)"
              >设为管理员</el-button>
              <el-button 
                v-else-if="row.role == 1  "
                type="text"
                @click="cancelAdmin(row)"
              >取消管理员</el-button>
              <el-button v-if="row.userId!=circleInfo.createBy"
                type="text"
                class="danger"
                @click="removeMember(row)"
              >移除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :current-page="memberPage"
          :page-size="10"
          :total="memberTotal"
          @current-change="handleMemberPageChange"
          layout="prev, pager, next,total"
        />
      </div>
    </el-dialog>
    <Pay ref="pay" @paySuccess="paySuccess"></Pay>
  </div>
    <el-dialog
        title="圈子文件"
        :visible.sync="fileDialogVisible"
        width="80%"
    >
      <file-manager :parent-id="$route.params.id"  :pre="!isOwner"></file-manager>
    </el-dialog>
    
    <!-- 审核不通过提示弹框 -->
    <el-dialog
      title="审核提示"
      :visible.sync="showAuditDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px"
      center
    >
      <div class="audit-content">
        <i class="el-icon-warning" style="color: #E6A23C; font-size: 48px; margin-bottom: 16px;"></i>
        <h3 style="color: #E6A23C; margin-bottom: 16px;">圈子审核未通过</h3>
        <p style="color: #666; line-height: 1.6;">
          您的圈子因不符合平台规范，审核未通过。<br>
          请联系管理员了解具体原因或重新提交审核。
        </p>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="goBack">返回圈子列表</el-button>
      </span>
    </el-dialog>
    
    <subscribe ref="subscribe"></subscribe>
  </div>
</template>

<script>
import _ from 'lodash'
import NavHeader from "@/components/layout/NavHeader.vue";
import HeadNav from "@/components/common/HeadNav.vue";
import Pay from "@/components/common/Pay.vue";
import PostPublish from "@/view/community/post-publish.vue";
import Subscribe from "@/components/common/subscribe.vue";
import FileManager from "@/components/FileManager/index.vue";
import Qrcode from "@/components/Qrcode/index.vue";
const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}
export default {
  name: 'PostList',
  components: {Qrcode, FileManager, Subscribe, PostPublish, Pay, NavHeader,HeadNav},

  data() {
    return {
      fileDialogVisible:false,
      pushDialog:false,
      circleInfo: {},
      channels: [],
      currentChannel: '',
      postType: 'all', // 帖子类型：all-全部, essence-精华
      posts: [],
      page: 1,
      total: 0,
      isOwner: false,
      isMember: false,
      showPayDialog: false,
      showManageDialog: false,
      showEssenceDialog: false,
      showTopDialog: false,
      essencePosts: [],
      topPosts: [],
      showMemberDialog: false,
      memberKeyword: '',
      members: [],
      memberPage: 1,
      memberTotal: 0,
      admins: [],
      isAdmin: false,
      owner:"",
      loading:false,
      searchKey: '',
      showAuditDialog: false
    }
  },
  created() {
    if(isMobileDevice()) location.href= process.env["VUE_APP_SHARE_BASE"]+"/h5/#/pages/community/circle-intro?id="+this.$route.params.id;
    this.loadCircleInfo()
  },

  methods: {
    // 加载圈子信息
    async loadCircleInfo() {
      try {
        const res = await this.$http2({
          url: `/klgeek/circle/${this.$route.params.id}`,
          method: 'GET'
        })
        this.circleInfo = res.data
        
        // 检查审核状态
        if (this.circleInfo.approved === 'N') {
          this.showAuditDialog = true
          return // 审核不通过时不再加载其他数据
        }
        
        this.channels = res.data.channels
          this.channels.unshift({
            id: '', // 确保"全部"的 id 为空字符串
            name: '最新'
          })
          this.currentChannel = '' // 默认选中"全部"
        this.loadPosts()
        this.loadAdminMembers()
        this.loadTop();
        this.$http2({
          url: "/im/user/" + this.circleInfo.createBy,
          method: 'GET'
        }).then((user) => {
          console.log(user)
          this.owner=user.data
        })
        if(!(sessionStorage.getItem("accessToken") ||localStorage.getItem("accessToken"))) return
        this.userStore.loadUser().then(()=>{
          if(!this.userStore.userInfo.openid){
            this.$refs.subscribe.showDialog();
          }
        })
        this.isOwner = this.circleInfo.createBy === this.userStore.userInfo.id
        const res2 = await this.$http2({
          url: `/klgeek/circleMember/check/${this.$route.params.id}`,
          method: 'GET'
        })
        this.isMember = res2.data;
      } catch(e) {
        console.error(e)
      }
    },

    // 加载帖子列表
    async loadPosts() {
      this.pushDialog=false;
      this.loading=true;
      try {
        const res = await this.$http2({
          url: '/klgeek/postList',
          params: {
            circleId: this.$route.params.id,
            channelId: this.currentChannel || undefined,
            isEssence: this.postType === 'essence' ? 1 : undefined,
            pageNum: this.isMember?this.page:1,     //未加入只能看部分数据
            pageSize: this.isMember?10:5,
            content: this.searchKey || undefined
          }
        })
        this.posts = res.rows
        this.total = res.total
        this.loading=false;
      } catch(e) {
        console.error(e)
      }
    },

    // 频道切换
    handleChannelChange(tab) {
      this.page = 1
      // 当切换到"全部"时,channelId 应该为空字符串
      this.currentChannel = tab.name || ''
      this.loadPosts()
    },

    // 切换精华状态
    toggleEssence() {
      this.postType = this.postType === 'essence' ? 'all' : 'essence'
      this.page = 1
      this.loadPosts()
    },

    // 页码变化
    handlePageChange(val) {
      this.page = val
      this.loadPosts()
    },

    // 点赞
    async toggleLike(post) {
      try {
        if(post.liked) {
          await this.$http2({
            url: `/klgeek/postLike`,
            data:{
              postId:post.id
            },
            method: 'PUT'
          })
          post.likeCount--
        } else {
          await this.$http2({
            url: `/klgeek/postLike`,
            data:{
              postId:post.id
            },
            method: 'POST'
          })
          post.likeCount++
        }
        post.liked = !post.liked
      } catch(e) {
        console.error(e)
      }
    },

    // 加入圈子
    joinCircle() {
      if(this.circleInfo.joinType === 1) {
        this.showPayDialog = true
      } else {
        this.join()
      }
    },

    // 免费加入
    async join(mchOrderNo) {
      try {
        await this.$http2({
          url: '/klgeek/circleMember',
          method: 'POST',
          data: {
            circleId: this.$route.params.id,
            mchOrderNo:mchOrderNo
          }
        })
        this.$message.success('加入成功')
        this.isMember = true
        this.loadCircleInfo()
      } catch(e) {
        this.$message.error(e.msg)
        console.error(e)
      }
    },
    /**
     * 支付成功
     * @param mchOrderNo
     */
    paySuccess(mchOrderNo){
      this.join(mchOrderNo)
    },
    // 显示支付
    showPay() {
      this.showPayDialog = false
      // 调用支付组件
      this.$refs.pay.openPay(this.$route.params.id,"circle");
    },

    // 获取文件图标
    getFileIcon(type) {
      const icons = {
        'doc,docx': 'el-icon-document',
        'xls,xlsx': 'el-icon-tickets',
        'ppt,pptx': 'el-icon-picture',
        'pdf': 'el-icon-document',
        'txt': 'el-icon-document-remove',
        'zip,rar,7z': 'el-icon-folder',
        'default': 'el-icon-document'
      }
      
      for(let key in icons) {
        if(key.split(',').includes(type)) {
          return icons[key]
        }
      }
      return icons.default
    },

    // 格式化文件大小
    formatSize(size) {
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while(size > 1024 && index < units.length - 1) {
        size = size / 1024
        index++
      }
      return size.toFixed(2) + units[index]
    },

    // 预览文件
    previewFile(file) {
      let linkUrl =null;
      if(file.type=='ppt'||file.type=='pptx'||file.type=='doc'||file.type=='docx'||file.type=='xls'||file.type=='pdf'||file.type=='xlsx')
      {
        linkUrl = "https://pan.imgbed.link/file/preview/"+file.id;
      }else{
        const encoder = new TextEncoder();
        const data = "https://pan.imgbed.link/file/"+file.id+"?fullfilename="+file.name;
        const encodedData = btoa(String.fromCharCode(...new Uint8Array(encoder.encode(data))));
        linkUrl ="https://pan.imgbed.link/kkpreview/onlinePreview?url="+encodeURIComponent(encodedData)
      }
      window.open(linkUrl)
    },

    // 下载文件
    async downloadFile(file) {
      try {
        // 发起请求获取文件blob
        const loading = this.$loading({
          lock: true,
          text: '下载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        });
        const response = await fetch(file.url, {
          method: 'GET',
        })
        const blob = await response.blob()
        loading.close()
        // 创建blob链接
        const blobUrl = window.URL.createObjectURL(blob)
        // 创建下载链接
        const downloadLink = document.createElement('a')
        downloadLink.href = blobUrl
        downloadLink.download = file.name // 设置下载文件名
        
        // 添加到body并触发点击
        document.body.appendChild(downloadLink)
        downloadLink.click()
        
        // 清理
        document.body.removeChild(downloadLink)
        window.URL.revokeObjectURL(blobUrl)
      } catch(e) {
        console.error('Download file error:', e)
        this.$message.error('下载失败')
      }
    },

    // 跳转到帖子详情
    goDetail(post) {
      if(this.$route.name=='postList'){
        this.$router.push(`/post-detail/${post.id}`)
      }else{
        this.$router.push(`/home/community/post-detail/${post.id}`)
      }

    },

    // 发布帖子
    publish() {
      if(!this.isMember){
        this.$confirm('加入后才可以发帖, 是否加入?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.joinCircle()
        }).catch(() => {

        });
      }else{
        this.$router.push(`/pushPost?circleId=${this.circleInfo.id}`)
        // this.pushDialog=true;
      }
    },

    // 圈子介绍
    goIntro() {
      // this.$router.push(`/community/circle-intro/${this.$route.params.id}`)
    },

    // 显示成员列表
    goMemberList() {
      this.showManageDialog = false
      this.showMemberDialog = true
      this.loadMembers()
    },

    // 显示管理弹窗
    showEditPopup() {
      this.showManageDialog = true
    },

    // 编辑圈子
    editCircle() {
      this.showManageDialog = false
      if(this.$route.name=='postList'){
        this.$router.push(`/circle-detail?id=${this.$route.params.id}`)
      }else{

        this.$router.push(`/home/community/circle-detail?id=${this.$route.params.id}`)
      }
    },

    // 精华管理
    async manageEssence() {
      this.showManageDialog = false
      try {
        const res = await this.$http2({
          url: '/klgeek/postList',
          params: {
            circleId: this.$route.params.id,
            isEssence:1
          }
        })
        this.essencePosts = res.rows
        this.showEssenceDialog = true
      } catch(e) {
        console.error(e)
      }
    },

    // 取消精华
    async cancelEssence(post) {
      try {
        await this.$http2({
          url: `/klgeek/post`,
          method: 'PUT',
          data: {
            isEssence: post.isEssence?0:1,
            id:post.id
          }
        })
        this.$message.success('设置成功')
        // this.essencePosts = this.essencePosts.filter(p => p.id !== post.id)
        this.loadPosts() // 刷新帖子列表
      } catch(e) {
        console.error(e)
      }
    },
    async loadTop(){
      const res = await this.$http2({
        url: '/klgeek/postList',
        params: {
          circleId: this.$route.params.id,
          isTop:1
        }
      })
      this.topPosts = res.rows
    },
    // 置顶管理
    async manageTop() {
      this.showManageDialog = false
      try {
        const res = await this.$http2({
          url: '/klgeek/postList',
          params: {
            circleId: this.$route.params.id,
            isTop:1
          }
        })
        this.topPosts = res.rows
        this.showTopDialog = true
      } catch(e) {
        console.error(e)
      }
    },

    // 取消/开启置顶
    async cancelTop(post) {
      try {
        await this.$http2({
          url: `/klgeek/post`,
          method: 'PUT',
          data: {
            isTop: post.isTop?0:1,
            id:post.id
          }
        })
        this.$message.success('设置成功')
        // this.topPosts = this.topPosts.filter(p => p.id !== post.id)
        this.loadTop();
        this.loadPosts() // 刷新帖子列表
      } catch(e) {
        console.error(e)
      }
    },

    // 加载成员列表
    async loadMembers() {
      try {
        const res = await this.$http2({
          url: '/klgeek/circleMember/list',
          params: {
            circleId: this.$route.params.id,
            keyword: this.memberKeyword,
            pageNum: this.memberPage,
            pageSize: 10
          }
        })
        this.members = res.rows
        this.memberTotal = res.total
      } catch(e) {
        console.error(e)
      }
    },
    /**
     * 加载管理员
     * @returns {Promise<void>}
     */
    async loadAdminMembers() {
      try {
        const res = await this.$http2({
          url: '/klgeek/circleMember/list',
          params: {
            circleId: this.$route.params.id,
            role: 1
          }
        })
        this.admins = res.rows
        this.isAdmin = this.admins.some(admin => admin.userId === this.userStore.userInfo.id)
      } catch(e) {
        console.error(e)
      }
    },

    // 搜索成员
    searchMember() {
      this.memberPage = 1
      this.loadMembers()
    },

    // 成员分页
    handleMemberPageChange(val) {
      this.memberPage = val
      this.loadMembers()
    },

    // 设置管理员
    async setAdmin(member) {
      try {
        await this.$http2({
          url: `/klgeek/circleMember/role`,
          method: 'PUT',
          data: {
            role: 1,
            id:member.id
          }
        })
        this.$message.success('设置成功')
        this.loadMembers()
      } catch(e) {
        console.error(e)
      }
    },

    // 取消管理员
    async cancelAdmin(member) {
      try {
        await this.$http2({
          url: `/klgeek/circleMember/role`,
          method: 'PUT',
          data: {
            role: 0,
            id:member.id
          }
        })
        this.$message.success('已取消管理员')
        this.loadMembers()
      } catch(e) {
        console.error(e)
      }
    },

    // 移除成员
    async removeMember(member) {
      this.$confirm('确定要移除该成员吗?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http2({
            url: `/klgeek/circleMember/${member.id}`,
            method: 'DELETE'
          })
          this.$message.success('已移除')
          this.loadMembers()
        } catch(e) {
          console.error(e)
        }
      })
    },

    // 处理命令
    handleCommand(command, post) {
      switch(command) {
        case 'essence':
          this.cancelEssence(post)
          break
        case 'cancelEssence':
          this.cancelEssence(post)
          break
        case 'top':
          this.cancelTop(post)
          break
        case 'cancelTop':
          this.cancelTop(post)
          break
        case 'delete':
          this.removePost(post)
          break
        case 'edit':
          this.$router.push(`/pushPost?id=${post.id}`)
          break
      }
    },

    // 移除帖子
    async removePost(post) {
      this.$confirm('确定要删除该帖子吗?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http2({
            url: `/klgeek/post/${post.id}`,
            method: 'DELETE'
          })
          this.$message.success('已删除')
          this.loadPosts()
        } catch(e) {
          console.error(e)
        }
      })
    },

    // 处理搜索
    handleSearch: _.debounce(function() {
      this.page = 1
      this.loadPosts()
    }, 300),

    // 返回圈子列表
    goBack() {
      if(this.$route.name=='postList'){
        this.$router.push('/circle')
      }else{
        this.$router.push('/home/community/circle-list')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'https://www.klgeek.com/css/bootstrap.min.css';
.post-list {
  height: 100%;
  margin: 0 auto;
  .fixed-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #f5f7fa;
    padding: 20px 20px 0;

    .circle-info {
      background-size: cover;
      background-position: center;
      position: relative;
      overflow: hidden;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0.1),
          rgba(0, 0, 0, 0.2)
        );
        z-index: 1;
      }

      .circle-header {
        display: flex;
        align-items: center;
        padding: 20px;
        position: relative;
        z-index: 2;
        
        .circle-user-info {
          flex: 1;
          margin: 0 20px;
          
          .circle-name {
            margin: 0 0 10px;
            color: #fff;
            text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
          }
          
          .circle-stats {
            color: rgba(255,255,255,0.8);
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
            
            span {
              margin-right: 20px;
              cursor: pointer;
              
              &:hover {
                color: #fff;
              }
            }
          }
        }
      }
    }

    .channel-bar {
      margin-bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);

      .left-section {
        flex: 1;
        overflow-x: auto;

        .el-tabs {
          min-width: min-content;
        }
      }

      .right-section {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-left: 16px;
        flex-shrink: 0;

        .search-box {
          width: 200px;
          
          .el-input {
            font-size: 13px;
            
            :deep(.el-input__inner) {
              height: 32px;
              line-height: 32px;
              border-radius: 16px;
              
              &:focus {
                border-color: #409EFF;
              }
            }
          }
        }

        .essence-btn {
          i {
            margin-right: 4px;
          }
        }

        .btn-publish {
          padding: 8px 16px;
          font-size: 14px;
          border-radius: 20px;
          box-shadow: 0 2px 8px rgba(64,158,255,0.2);
          transition: all 0.3s ease;

          i {
            margin-right: 4px;
            font-size: 16px;
            vertical-align: middle;
          }

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(64,158,255,0.3);
          }
        }
      }
    }
  }

  .post-container {
    padding: 20px;
    //max-width: 800px;
    //margin: 0 auto;

    .top-posts {
      background: #f8f9fa;
      border-radius: 4px;
      padding: 12px 16px;
      margin-bottom: 20px;

      .top-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        
        i {
          color: #f56c6c;
          margin-right: 6px;
        }
        
        span {
          font-size: 14px;
          color: #606266;
        }
      }

      .top-list {
        .top-item {
          display: flex;
          align-items: center;
          cursor: pointer;
          border-bottom: 1px solid #ebeef5;
          
          &:last-child {
            border-bottom: none;
          }
          
          &:hover {
            .post-title {
              color: #409EFF;
            }
          }

          .top-tag {
            color: #f56c6c;
            font-size: 13px;
            width: 40px;
            flex-shrink: 0;
          }

          .post-title {
            flex: 1;
            color: #303133;
            font-size: 14px;
            // 文字超出显示省略号
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .post-item {
      margin-bottom: 20px;
      cursor: pointer;
      
      &.is-essence {
        border: 1px solid #67C23A;
      }
      
      .post-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
        
        .circle-user-info {
          display: flex;
          align-items: center;
          
          .user-meta {
            margin-left: 10px;
            
            .nickname {
              display: block;
              font-weight: bold;
            }
            
            .time {
              font-size: 12px;
              color: #999;
            }
          }
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 12px;

          .post-tags {
            display: flex;
            gap: 8px;
          }

          .post-actions {
            .el-button {
              padding: 0;
              
              i {
                font-size: 20px;
                color: #909399;
              }
              
              &:hover i {
                color: #409EFF;
              }
            }
          }
        }
      }
      
      .post-content {
        .post-text {
          margin-bottom: 15px;
          line-height: 1.6;
          font-size: 1rem;
          &.is-title{
            font-weight: bold;
          }
        }
        
        .image-list {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
          margin-bottom: 15px;
          
          .el-image {
            width: 100%;
            height: 200px;
            border-radius: 4px;
          }
        }
        
        .file-list {
          .file-item {
            display: flex;
            align-items: center;
            padding: 10px;
            background: #f5f5f5;
            border-radius: 4px;
            margin-bottom: 10px;
            
            i {
              font-size: 24px;
              margin-right: 10px;
            }
            
            .file-name {
              flex: 1;
              margin-right: 10px;
            }
            
            .file-size {
              color: #999;
              margin-right: 10px;
            }
          }
        }
      }
      
      .post-footer {
        display: flex;
        justify-content: flex-end;
        padding-top: 15px;
        border-top: 1px solid #eee;
        
        .post-actions {
          span {
            margin-left: 20px;
            color: #666;
            cursor: pointer;
            
            i {
              margin-right: 5px;
            }
            
            &:hover {
              color: #409EFF;
            }
          }
        }
      }
    }

    .pagination {
      display: flex;
      justify-content: center;
      margin: 20px 0;
    }

    .publish-btn {
      position: fixed;
      right: 40px;
      bottom: 40px;
      z-index: 99;

      .btn-publish {
        padding: 12px 24px;
        font-size: 16px;
        border-radius: 24px;
        box-shadow: 0 4px 12px rgba(64,158,255,0.3);
        transition: all 0.3s ease;

        i {
          margin-right: 6px;
          font-size: 18px;
          vertical-align: middle;
        }

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(64,158,255,0.4);
        }
      }
    }
  }

  .pay-content {
    .pay-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      
      .price {
        color: #F56C6C;
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  .manage-menu {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    
    .el-button {
      margin: 10px 0;
      text-align: left;
    }
  }

  .search-bar {
    margin-bottom: 20px;
  }

  .member-info {
    display: flex;
    align-items: center;

    .nickname {
      margin-left: 10px;
    }
  }

  .danger {
    color: #F56C6C;
    
    &:hover {
      color: #f78989;
    }
  }

  .pagination {
    margin-top: 20px;
    text-align: center;
  }

  .circle-info-card {
    margin-top: 20px;
    .info-header {
      margin-bottom: 15px;
      
      h3 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
      }
    }

    .info-content {
      .description {
        color: #666;
        line-height: 1.6;
        margin-bottom: 15px;
      }

      .info-stats {
        display: flex;
        margin-bottom: 15px;
        
        .stat-item {
          flex: 1;
          text-align: center;
          
          .label {
            display: block;
            font-size: 12px;
            color: #999;
          }
          
          .value {
            font-size: 16px;
            font-weight: bold;
            color: #333;
          }
        }
      }

      .info-meta {
        margin-bottom: 15px;
        
        .owner-info {
          display: flex;
          align-items: flex-start;
          padding: 10px;
          background: #f8f9fa;
          border-radius: 8px;
          
          .owner-avatar {
            flex-shrink: 0;
            margin-right: 12px;
            cursor: pointer;
            
            &:hover {
              transform: scale(1.05);
              transition: transform 0.2s ease;
            }
          }
          
          .owner-meta {
            flex: 1;
            
            .owner-name {
              display: flex;
              align-items: center;
              font-weight: 500;
              color: #333;
              margin-bottom: 6px;
              
              i {
                margin-right: 5px;
                color: #409EFF;
              }
            }
            
            .create-time {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #999;
              
              i {
                margin-right: 5px;
              }
            }
          }
        }
      }

      .join-info {
        text-align: center;
        padding-top: 15px;
        border-top: 1px solid #eee;
        
        .price {
          font-size: 24px;
          color: #F56C6C;
          font-weight: bold;
          margin-bottom: 5px;
        }
        
        .valid-days {
          font-size: 12px;
          color: #999;
          margin-bottom: 10px;
        }
        
        .join-btn {
          width: 100%;
        }
      }
    }
  }

  .admin-card {
    .admin-list {
      .admin-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .admin-name {
          margin-left: 10px;
          color: #666;
        }
      }
    }
  }
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.channel-bar {
  background: #fff;
  border-radius: 8px;
  padding: 0 20px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .channel-scroll {
    overflow-x: auto;
    flex: 1;
    
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      height: 6px;
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 3px;
      
      &:hover {
        background: #ccc;
      }
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    .scrollable-tabs {
      :deep(.el-tabs__header) {
        margin: 0;
        margin-bottom: 6px; /* 为滚动条留出空间 */
      }
      
      :deep(.el-tabs__nav-wrap) {
        padding: 0;
        
        &::after {
          display: none;
        }
      }
      
      :deep(.el-tabs__nav-scroll) {
        overflow: visible;
      }
      
      :deep(.el-tabs__nav) {
        white-space: nowrap;
        display: flex;
        float: none;
      }
      
      :deep(.el-tabs__item) {
        flex-shrink: 0;
        padding: 0 20px;
        line-height: 50px;
      }
    }
  }

  .right-section {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: 16px;
    flex-shrink: 0;

    .search-box {
      width: 200px;
      
      .el-input {
        font-size: 13px;
        
        :deep(.el-input__inner) {
          height: 32px;
          line-height: 32px;
          border-radius: 16px;
          
          &:focus {
            border-color: #409EFF;
          }
        }
      }
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .channel-bar {
    padding: 0 10px;
    
    .channel-scroll {
      .scrollable-tabs {
        :deep(.el-tabs__item) {
          padding: 0 15px;
        }
      }
    }
    
    .right-section {
      margin-left: 10px;
    }
  }
}

.audit-content {
  text-align: center;
  padding: 20px 0;
  
  i {
    display: block;
    margin: 0 auto;
  }
  
  h3 {
    margin: 16px 0;
    font-size: 18px;
    font-weight: 500;
  }
  
  p {
    margin: 0;
    font-size: 14px;
  }
}
</style> 